<template>
  <div class="animated fadeIn">
    <QuizContent v-if="$route.params.type == 'quiz'"></QuizContent>
    <RelacionarContent v-if="$route.params.type == 'relacionar'"></RelacionarContent>
    <PizarraContent v-if="$route.params.type == 'pizarra'"></PizarraContent>
  </div>
</template>

<script>

//import QuizContent from "@/components/QuizContent.vue";
//import RelacionarContent from "@/components/RelacionarContent.vue";
import PizarraContent from "@/components/constructor/PizarraContent.vue";

export default {
  name: "Actividades",
  data() {
    return {}
  },
  components: {
   // QuizContent,
    //RelacionarContent,
    PizarraContent
  },
  watch: {
    $route(to, from) {
      console.log(to);
    }
  },  
};
</script>

